// extracted by mini-css-extract-plugin
export default {"fbLoginButton":"cm3ic4nuf"};